<script>
	import { onMount } from "svelte";
	import { CountUp } from "countup.js";
	import Highcharts from "highcharts";
	import * as animateScroll from "svelte-scrollto";

	animateScroll.setGlobalOptions({
		container: "#scrollarea",
		scrollX: true,
		scrollY: false,
		duration: 200,
	});

	let todayDate = "";
	let tomorrowDate = "";

	let todayDataExists = true;
	let tomorrowDataExists = true;
	let morgendagensDusjpriser;
	let dagensDusjPriser;
	let dusjpris = (spotprisOreprKwH, elavgift, nettleie, dusjforbruk) =>
		(spotprisOreprKwH / 100 + elavgift + nettleie) * 1.25 * dusjforbruk; //1.25 er moms - dusjforbruk 5kwh

	onMount(async () => {
		/*
		const {
			historic: { dates: historicDates, prices: historicPrices },
		} = await fetch(
			"https://www.vg.no/spesial/2021/strompriser/api/historic/"
		).then((response) => response.json());
		*/

		const {
			priceByHour: { hours, prices, date: todaysDateResult, isToday },
		} = await fetch(
			"https://www.vg.no/spesial/2021/strompriser/api/today/" //"https://www.vg.no/spesial/2021/strompriser/api/day-ahead/"
		).then((response) => response.json());
		todayDataExists = isToday;
		if (!isToday) {
			return;
		}
		const {
			priceByHour: {
				hours: tomorrowHours,
				prices: tomorrowPrices,
				date: tomorrowsDateResult,
				isTomorrow,
			},
		} = await fetch(
			"https://www.vg.no/spesial/2021/strompriser/api/day-ahead/"
		).then((response) => response.json());

		tomorrowDataExists = isTomorrow;
		todayDate = todaysDateResult;
		tomorrowDate = tomorrowsDateResult;

		const pricesOslo = prices.find((city) => city.name == "oslo");
		const pricesOsloTomorow = tomorrowPrices.find(
			(city) => city.name == "oslo"
		);

		const elavgift = 0.0891;
		const nettleie = 0.2467;
		const now = new Date();

		const currentHour =
			now.getHours() < 10 ? "0" + now.getHours() : now.getHours();

		const currentIndex = hours.findIndex((something) =>
			something.startsWith(currentHour)
		);
		const timepriserNaa = pricesOslo.data[currentIndex];

		const dusjindeks = dusjpris(timepriserNaa, elavgift, nettleie, 5);

		var countOptions = {
			useEasing: true,
			duration: 1,
			decimals: 2,
		};
		var count = new CountUp("dusjindexCountUp", dusjindeks, countOptions);

		count.start();

		const dagensStromPriser = pricesOslo.data;
		const morgendagensStromPriser = pricesOsloTomorow.data;
		dagensDusjPriser = dagensStromPriser.map((spotpris) => {
			const pris = dusjpris(spotpris, elavgift, nettleie, 5);
			return Math.round(pris * 100) / 100;
		});

		morgendagensDusjpriser = morgendagensStromPriser.map((spotpris) => {
			const pris = dusjpris(spotpris, elavgift, nettleie, 5);
			return Math.round(pris * 100) / 100;
		});

		const graphmax = Math.max(
			...morgendagensDusjpriser.concat(dagensDusjPriser)
		);
		const graphmin = Math.min(
			...morgendagensDusjpriser.concat(dagensDusjPriser)
		);

		const vekstOljefondetGraph = Highcharts.chart("dusjprisGraph", {
			chart: {
				type: "line",
				height: (2 / 3.2) * 100 + "%",
				backgroundColor: "rgba(255, 255, 255, 0)",
				style: {
					fontFamily: "E24 text",
				},
			},
			title: {
				text: null,
			},
			legend: {
				enabled: false,
			},

			plotOptions: {
				line: { marker: { enabled: false }, lineWidth: 5 },
			},
			credits: {
				enabled: false,
			},
			tooltip: {
				valueDecimals: 2,
				valueSuffix: " Kr",
			},
			xAxis: {
				categories: hours.map((hour) => `${hour.substring(0, 2)}:00`),
			},
			yAxis: {
				title: {
					text: "Pris for dusj",
					enabled: false,
				},
			},

			yAxis: {
				//visible: false,
				gridLineColor: "transparent",
				title: { enabled: false },
				max: graphmax,
				min: graphmin,
			},
			series: [
				{
					name: "Dusjpris",
					data: dagensDusjPriser,
					color: "#E6303A",
				},
			],
		});
		const morgendagensGraf = Highcharts.chart("morgendagensGraf", {
			chart: {
				type: "line",
				height: (2 / 3.2) * 100 + "%",
				backgroundColor: "rgba(255, 255, 255, 0)",
				style: {
					fontFamily: "E24 text",
				},
			},
			title: {
				text: null,
			},
			legend: {
				enabled: false,
			},
			tooltip: {
				valueDecimals: 2,
				valueSuffix: " Kr",
			},
			plotOptions: {
				line: { marker: { enabled: false }, lineWidth: 5 },
			},
			credits: {
				enabled: false,
			},
			xAxis: {
				categories: tomorrowHours.map(
					(hour) => `${hour.substring(0, 2)}:00`
				),
			},
			yAxis: {
				title: {
					text: "Pris for dusj",
					enabled: false,
				},
			},
			yAxis: {
				//visible: false,
				gridLineColor: "transparent",
				title: { enabled: false },
				max: graphmax,
				min: graphmin,
			},
			series: [
				{
					name: "Dusjpris",
					data: morgendagensDusjpriser,
					color: "#E6303A",
				},
			],
		});
	});
</script>

<style>
	.dusjindex {
		background-color: #74c1ff;
		font-family: "E24 Text", "Arial", "sans-serif";
		width: 100%;
		box-sizing: border-box;
		height: 100vw;
		max-width: 648px;
		max-height: 648px;
		overflow-x: scroll;
		scroll-snap-type: x mandatory;
		scroll-behavior: smooth;
	}
	.dusjindex-title {
		font-size: 4em;
		flex: 0 1 auto;
		margin: 5px 0;
		flex: 0 1 auto;
	}
	.explanation {
		font-size: 10px;
		position: absolute;
		bottom: 3px;
		z-index: 5;
		text-align: center;
		width: 100%;
		color: #333333;
	}
	.scrollsection1 {
		position: relative;
		display: flex;
		width: 100%;
		height: 100%;
	}
	.scrollsection2 {
		position: relative;
		display: flex;
		width: 200%;
		height: 100%;
	}

	.scrollsection3 {
		position: relative;
		display: flex;
		width: 300%;
		height: 100%;
	}

	.dusjkort {
		position: relative;
		display: flex;
		flex-flow: column;
		height: 100%;
		width: 100%;
		box-sizing: border-box;
		padding: 1.5%;
		scroll-snap-align: start;
	}
	.innerLable {
		font-size: 2em;
		margin-left: 15px;
		margin-top: 10px;
	}
	.showerprice {
		font-size: 5em;
		font-weight: 700;
		text-align: center;
		font-family: "E24 Text", "Arial", "sans-serif";
		width: 100%;
		position: absolute;
		bottom: 15px;
	}
	.dusjbilde {
		background-image: url("https://e24.vgc.no/spesial/2021/10/strompriser/static/dusj.gif");
		background-repeat: no-repeat;
		background-size: 75%;
		width: 100%;
		height: 70%;
		overflow: hidden;
		background-position: center top;
		bottom: 0px;
		position: absolute;
	}
	.visualizationarea {
		position: relative;
		background-image: url("https://e24.vgc.no/spesial/2021/10/strompriser/static/tile.png");
		background-size: 8vh;
		background-position: center;
		height: 100%;
		background-color: white;
		flex: 1 1 auto;
		width: 100%;
		overflow: hidden;
	}
	.arrow-right {
		width: 0;
		height: 0;
		border-top: 15px solid transparent;
		border-bottom: 15px solid transparent;
		top: 60%;
		margin-top: -15px;
		border-left: 30px solid #e6303a;
		position: absolute;
		right: 40px;
	}
	.arrow-left {
		width: 0;
		height: 0;
		top: 60%;
		margin-top: -15px;
		border-top: 15px solid transparent;
		border-bottom: 15px solid transparent;
		border-right: 30px solid #e6303a;
		position: absolute;
		left: 40px;
	}
	.damp {
		position: absolute;
		width: 200px;
		height: 200px;
		background-color: lightblue;
		border-radius: 50%;
		z-index: 10;
		text-align: center;
		top: 50%;
		margin-left: -50px;
		margin-top: -50px;
		left: 50%;
		opacity: 0;
	}
	.damp-en {
		animation: damp-en 5s ease-out infinite;
	}

	@keyframes damp-en {
		0% {
			transform: translateY(0) translateX(0) scale(0.2);
			opacity: 0;
		}
		10% {
			opacity: 0.3;
		}
		100% {
			transform: translateY(-200px) translateX(-20px) scale(1);
			opacity: 0;
		}
	}
	.damp-to {
		animation: damp-to 7s ease-out infinite;
	}

	@keyframes damp-to {
		0% {
			transform: translateY(0) translateX(40px) scale(0.1);
			opacity: 0;
		}
		10% {
			opacity: 0.4;
		}
		100% {
			transform: translateY(-200px) translateX(50px) scale(0.8);
			opacity: 0;
		}
	}

	.damp-tre {
		animation: damp-tre 2s ease-out infinite;
	}

	@keyframes damp-tre {
		0% {
			transform: translateY(0) translateX(-20px) scale(0.1);
			opacity: 0;
		}
		10% {
			opacity: 0.1;
		}
		100% {
			transform: translateY(-200px) translateX(50px) scale(0.4);
			opacity: 0;
		}
	}

	@media (max-width: 550px) {
		.dusjindex-title {
			font-size: 3.5em;
		}
		.showerprice {
			font-size: 3.5em;
		}
		.innerLable {
			font-size: 1.5em;
		}
		.arrow-right {
			border-top: 9px solid transparent;
			border-bottom: 9px solid transparent;
			margin-top: -9px;
			border-left: 15px solid #e6303a;
			right: 25px;
		}
		.arrow-left {
			margin-top: -9px;
			border-top: 9px solid transparent;
			border-bottom: 9px solid transparent;
			border-right: 15px solid #e6303a;
			left: 25px;
		}
	}
	@media (max-width: 440px) {
		.dusjindex-title {
			font-size: 3em;
		}
		.showerprice {
			font-size: 3em;
		}
		.innerLable {
			font-size: 1.2em;
		}
	}
	@media (max-width: 380px) {
		.dusjindex-title {
			font-size: 2.5em;
		}
		.showerprice {
			font-size: 2.5em;
		}
		.innerLable {
			font-size: 1em;
		}
	}
</style>

<main>
	<div id="scrollarea" class="dusjindex">
		<div
			id="container"
			class={todayDataExists ? (tomorrowDataExists ? 'scrollsection3' : 'scrollsection2') : 'scrollsection1'}>
			{#if todayDataExists}
				<div id="kort1" class="dusjkort">
					<h3 class="dusjindex-title">Dusjindeks</h3>
					<div class="visualizationarea">
						<p class="innerLable">
							Akkurat nå koster en dusj i Oslo
						</p>
						<div class="dusjbilde" />
						<div class="showerprice">
							<span id="dusjindexCountUp">0</span>
							kr
						</div>
						<div class="damp damp-en" />
						<div class="damp damp-to" />
						<div class="damp damp-tre" />
						<div class="explanation">
							Om du bruker et generøst dusjhode i 10 minutter
						</div>
					</div>
					<div
						class="arrow-right"
						on:click={() => animateScroll.scrollTo({
								element: '#kort2',
							})} />
				</div>
				<div id="kort2" class="dusjkort">
					<h3 class="dusjindex-title">Prisene i dag</h3>
					<div class="visualizationarea">
						<p class="innerLable">{todayDate}</p>
						<div id="dusjprisGraph" />
					</div>
					<div
						class="arrow-left"
						on:click={() => animateScroll.scrollTo({
								element: '#kort1',
							})} />
					{#if tomorrowDataExists}
						<div
							class="arrow-right"
							on:click={() => animateScroll.scrollTo({
									element: '#kort3',
								})} />
					{/if}
				</div>
			{:else}
				<div class="dusjkort">
					<div id="kort1" class="dusjkort">
						<h3 class="dusjindex-title">Dusjindeks</h3>
						<div class="visualizationarea">
							<p class="innerLable">
								Kunne ikke laste strømprisene
							</p>
							<div class="dusjbilde" />
							<div class="showerprice">Sorry</div>
							<div class="damp damp-en" />
							<div class="damp damp-to" />
							<div class="damp damp-tre" />
						</div>
					</div>
				</div>
			{/if}
			{#if todayDataExists && tomorrowDataExists}
				<div id="kort3" class="dusjkort">
					<h3 class="dusjindex-title">.. i morgen</h3>
					<div class="visualizationarea">
						<p class="innerLable">{tomorrowDate}</p>
						<div id="morgendagensGraf" />
					</div>
					<div
						class="arrow-left"
						on:click={() => animateScroll.scrollTo({
								element: '#kort2',
							})} />
				</div>
			{/if}
		</div>
	</div>
</main>
